import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {RacunZaProvizijuDocument} from "./RacunZaProvizijuDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: opis, lista priloga, tekući račun, datum valute

export const racunZaProvizijuDocumentFields: IntercateKeysMap<RacunZaProvizijuDocument, EntityField<RacunZaProvizijuDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	dueDate: {
		name: "dueDate", dataType: EntityFieldDataType._date, label: "Datum valute",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	accountNumber: {
		name: "accountNumber", dataType: EntityFieldDataType._string, label: "Broj računa",
		validator: { required: false },
		sortable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<RacunZaProvizijuDocument>> = [
	racunZaProvizijuDocumentFields.indexingNumber,
	racunZaProvizijuDocumentFields.indexingDate,
	racunZaProvizijuDocumentFields.documentNumber,
	racunZaProvizijuDocumentFields.documentDate,
	racunZaProvizijuDocumentFields.assignedTo,
	racunZaProvizijuDocumentFields.clientId,
	racunZaProvizijuDocumentFields.sectorId,
	racunZaProvizijuDocumentFields.tags,
	racunZaProvizijuDocumentFields.dueDate,
	racunZaProvizijuDocumentFields.accountNumber,
	racunZaProvizijuDocumentFields.parentId
]

export const racunZaProvizijuDocumentFieldsDescriptor: EntityFieldsDescriptor<RacunZaProvizijuDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
